module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-pricing-rule-component"
  }, [_c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('div', [(_vm.errors.message) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.message)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 "
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputs.name),
      expression: "inputs.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "min": "1",
      "maxlength": "100",
      "placeholder": _vm.t('Rule name')
    },
    domProps: {
      "value": (_vm.inputs.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputs, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.hasError('name')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Base price')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Set parameter')) + " (" + _vm._s(_vm.t('parameter name which contains purchase price')) + ")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputs.priceAttributeName),
      expression: "inputs.priceAttributeName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.inputs.priceAttributeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputs, "priceAttributeName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.hasError('priceAttributeName')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.priceAttributeName)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Set minimal profit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Value')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputs.minimalProfitValue),
      expression: "inputs.minimalProfitValue"
    }],
    staticClass: "controls form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": _vm.maxInputValue
    },
    domProps: {
      "value": (_vm.inputs.minimalProfitValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputs, "minimalProfitValue", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.hasError('minimalProfitValue')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.minimalProfitValue)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Kind')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.getTypeOptions(),
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.inputs.minimalProfitKind),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "minimalProfitKind", $$v)
      },
      expression: "inputs.minimalProfitKind"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1), _vm._v(" "), (_vm.hasError('minimalProfitKind')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.minimalProfitKind)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Set maximal profit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Value')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputs.maximalProfitValue),
      expression: "inputs.maximalProfitValue"
    }],
    staticClass: "controls form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": _vm.maxInputValue
    },
    domProps: {
      "value": (_vm.inputs.maximalProfitValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputs, "maximalProfitValue", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.hasError('maximalProfitValue')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.maximalProfitValue)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Kind')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.getTypeOptions(),
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.inputs.maximalProfitKind),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "maximalProfitKind", $$v)
      },
      expression: "inputs.maximalProfitKind"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1), _vm._v(" "), (_vm.hasError('maximalProfitKind')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.maximalProfitKind)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Competition')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-end"
  }, [_c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Set competitions')) + " (" + _vm._s(_vm.t('leave empty to get all')) + ")")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.availableShops,
      "multiple": true,
      "limit": 10,
      "options-limit": 1000,
      "limit-text": _vm.limitText,
      "close-on-select": false,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name",
      "loading": _vm.shopsLoadingFilter
    },
    on: {
      "open": _vm.onOpenShops
    },
    model: {
      value: (_vm.inputs.shops),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "shops", $$v)
      },
      expression: "inputs.shops"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1), _vm._v(" "), (_vm.selectedShopIsAuctions) ? _c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Set sellers')) + " (" + _vm._s(_vm.t('leave empty to get all')) + ")")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.availableSellers,
      "multiple": true,
      "limit": 10,
      "options-limit": 1000,
      "limit-text": _vm.limitText,
      "close-on-select": false,
      "clear-on-select": false,
      "group-values": "rows",
      "group-label": "name",
      "group-select": true,
      "track-by": "id",
      "label": "name",
      "loading": _vm.sellersLoadingFilter
    },
    on: {
      "open": _vm.onOpenSellers
    },
    model: {
      value: (_vm.inputs.sellers),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "sellers", $$v)
      },
      expression: "inputs.sellers"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Indicate a competitive benchmark price')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.getPriceStrategies(),
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.inputs.priceStrategy),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "priceStrategy", $$v)
      },
      expression: "inputs.priceStrategy"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1), _vm._v(" "), (_vm.hasError('priceStrategy')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.priceStrategy)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Strategy')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Set strategy')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.getStrategies(),
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.inputs.strategy),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "strategy", $$v)
      },
      expression: "inputs.strategy"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1), _vm._v(" "), (_vm.displayStrategyValueComputed) ? _c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Value')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputs.strategyValue),
      expression: "inputs.strategyValue"
    }],
    staticClass: "controls form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": _vm.maxInputValue
    },
    domProps: {
      "value": (_vm.inputs.strategyValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputs, "strategyValue", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.hasError('strategyValue')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.strategyValue)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayStrategyPosition) ? _c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Position nr')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputs.strategyPosition),
      expression: "inputs.strategyPosition"
    }],
    staticClass: "controls form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.inputs.strategyPosition)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputs, "strategyPosition", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.displayStrategyValueComputed) ? _c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Kind')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.getTypeOptions(),
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.inputs.strategyKind),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "strategyKind", $$v)
      },
      expression: "inputs.strategyKind"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])]), _vm._v(" "), (_vm.hasError('strategyKind')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.strategyKind)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.errors.strategy) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.strategy)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 form-group"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Round')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.t('Verification of the minimum price occurs after calculating the price for the product. The subsequent rounding of the price may cause it to be lower than the minimum price.')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Round type')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.getRoundType(),
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.inputs.roundType),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "roundType", $$v)
      },
      expression: "inputs.roundType"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])]), _vm._v(" "), (_vm.hasError('roundType')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.roundType)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Round mode')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.getRoundDirection(),
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.inputs.roundMode),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "roundMode", $$v)
      },
      expression: "inputs.roundMode"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])]), _vm._v(" "), (_vm.hasError('roundMode')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.roundMode)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Difference from rounded amount')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputs.roundDifferent),
      expression: "inputs.roundDifferent"
    }],
    staticClass: "controls form-control",
    attrs: {
      "type": "number",
      "min": "-10",
      "max": "10"
    },
    domProps: {
      "value": (_vm.inputs.roundDifferent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputs, "roundDifferent", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.hasError('roundDifferent')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.roundDifferent))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-confirm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Submit')) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cc9f1c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicPricingRuleComponent.vue
// module id = 1302
// module chunks = 2